import axios from "axios";

const apiURL = "https://cryptogt-admin-backend.onrender.com/api/";
// const apiURL = "http://localhost:5000/api/";

// Public (no token) request that surfaces the server's own message so the
// portal can show "no active hybrid package", cooldown dates, etc.
const MakePublicRequest = async (endpoint, method = "GET", data = null) => {
  try {
    const response = await axios({
      method,
      url: `${apiURL}${endpoint}`,
      headers: { "Content-Type": "application/json" },
      data,
    });
    return response.data;
  } catch (error) {
    const serverMsg =
      error.response?.data?.message || error.response?.data?.error;
    if (serverMsg) throw new Error(serverMsg);
    throw new Error("Something went wrong. Please try again.");
  }
};

// Credit 950 CGT coins to the CGT Homes wallet linked to a CryptoGT ID
export const creditCGTHomesCoins = async (userId) => {
  return await MakePublicRequest("public/credit-cgthomes-coins", "POST", { userId });
};

// Full credit history for the public portal
export const getCGTHomesCoinCreditHistory = async () => {
  return await MakePublicRequest("public/cgthomes-coin-credit-history", "GET");
};
